import React, { useEffect } from 'react';
import { UnknownIntent } from '@debbie/common/dist/intents/index.js';
const UnknownCreator = (props) => {
    const onEdit = () => {
        props.onEdit(UnknownIntent());
    };
    useEffect(() => {
        onEdit();
    }, []);
    return React.createElement(React.Fragment, null);
};
export default UnknownCreator;
//# sourceMappingURL=UnknownCreator.js.map